/** @typedef {'live' | 'frozen' | 'working-base'} EditorSceneMediaPolicy */

export function editorSceneMediaPolicyFromPins(pinnedCloudId, pinnedLocalFile) {
  if (pinnedCloudId || pinnedLocalFile) return 'frozen';
  return 'live';
}

export function shouldFreezeEditorSceneMedia(mediaPolicy) {
  return mediaPolicy === 'frozen' || mediaPolicy === 'working-base';
}

/**
 * When freezeMedia is true, keep clip media URLs/timing; only refresh script labels.
 * Pass `resolveSceneMediaUrl(scene, field)` to fill gaps from the latest segment row.
 * @param {object} clip
 * @param {object} scene
 * @param {{ freezeMedia?: boolean, script?: string, name?: string, resolveSceneMediaUrl?: (scene: object, field: string) => string|null }} opts
 */
export function mergeTimelineClipFrozenFields(clip, scene, {
  freezeMedia,
  script,
  name,
  resolveSceneMediaUrl,
} = {}) {
  if (!clip || !scene) return clip;
  if (!freezeMedia) return clip;
  const narrationText = script ?? scene.narration_text ?? scene.scene_text ?? clip.narrationText;
  const resolve = typeof resolveSceneMediaUrl === 'function'
    ? resolveSceneMediaUrl
    : (row, field) => (row?.[field] ? String(row[field]).trim() : null);
  const frozen = {
    ...clip,
    name: name ?? scene.title ?? scene.scene_title ?? clip.name,
    sceneText: scene.scene_text || scene.narration_text || clip.sceneText,
    narrationText,
    audioUrl: clip.audioUrl || resolve(scene, 'audio_url'),
    imageUrl: clip.imageUrl || resolve(scene, 'image_url'),
    videoUrl: clip.videoUrl || resolve(scene, 'video_url'),
    duration: clip.duration,
    playbackDuration: clip.playbackDuration,
    trimStart: clip.trimStart,
    trimEnd: clip.trimEnd,
  };
  if (!frozen.sceneMediaUpdatedAt && scene.updated_at) {
    frozen.sceneMediaUpdatedAt = scene.updated_at;
  }
  return frozen;
}
